import React, {Component} from 'react';
import './AboutUs.css';
import AboutUsCard from './AboutUsCard.js'
import agritech from '../../../images/pplogo-192-agritech.png';
import capital from '../../../images/pplogo-192-capital.png';
import energy from '../../../images/pplogo-192-energy.png';
import medical from '../../../images/pplogo-192-health.png';
import realestate from '../../../images/pplogo-192-realestate.png';
import agritechTitle from '../../../images/maintitle/agritechMainTitle.jpg';
import energyTitle from '../../../images/maintitle/energyMainTitle.jpg';
import medicalTitle from '../../../images/maintitle/medicalMainTitle.jpg';
import realestateTitle from '../../../images/maintitle/realEstateMainTitle.jpg';
import { faNetworkWired, faBuilding } from '@fortawesome/free-solid-svg-icons';


export default class AboutUs extends Component {

	render() {

		return (
			<div className="about_us_container">
				<div className="about_us_title">
					<span>ABOUT US</span>
				</div>
				<div className="about_us_content">
					<AboutUsCard title="COMPANY PROFILE" icon={faNetworkWired} description="Find out more about the History, Philosphy and Beliefs of Pacific Prince International." link='/companyprofile' />
					<AboutUsCard title="OUR NETWORK" icon={faBuilding} description="Explore the areas where Pacific Prince International has left a footprint, in one way or another." link='/network' />
				</div>
			</div>
		)
	}
};
